import { withTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'

const NotFound = ({i18n, t}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const from = location.state?.from?.pathname || '/dashboard'

  return (
    <div className='error'>
      <h1>{t('error.not_found.title')}</h1>
      <p>{t('error.not_found.message')}</p>
      <button type='button' className='cancel' onClick={() => navigate(from)}>
        {t('buttons.back')}
      </button>
    </div>
  )
}

export default withTranslation('ui')(NotFound)
